import ElementUI from 'element-ui';
import Vue from 'vue';
import App from './App';
import './assets/iconfont/iconfont.css';
import './assets/style/im.scss';
import imIconfontUrl from './assets/iconfont/iconfont.ttf';
import elementIconsWoffUrl from 'element-ui/lib/theme-chalk/fonts/element-icons.woff';
import flagFontUrl from './assets/style/font/TwemojiCountryFlags.woff2';
import router from './router';

import * as date from './api/date.js';
import element from './api/element.js';
import emotion from './api/emotion.js';
import * as enums from './api/enums.js';
import httpRequest from './api/httpRequest';
import * as messageType from './api/messageType';
import url from './api/url.js';
import * as socketApi from './api/wssocket';
import store from './store';
import './utils/directive/dialogDrag';
import versionChecker from './utils/unifiedVersionCheck';
import { resolveMediaUrl, resolveMediaUrlList } from './utils/mediaUrl';
import { installH5Layout } from './utils/h5';

installH5Layout();

Vue.use(ElementUI);
// 挂载全局
Vue.prototype.$wsApi = socketApi;
Vue.prototype.$msgType = messageType
Vue.prototype.$date = date;
Vue.prototype.$http = httpRequest // http请求方法
Vue.prototype.$emo = emotion; // emo表情
Vue.prototype.$url = url; // url转换
Vue.prototype.$elm = element; // 元素操作
Vue.prototype.$enums = enums; // 枚举
Vue.prototype.$eventBus = new Vue(); // 全局事件
Vue.config.productionTip = false;

Vue.mixin({
	methods: {
		$mediaUrl(url) {
			return resolveMediaUrl(url, this.$store.state.configStore.s3Url);
		},
		$mediaUrlList(urls) {
			return resolveMediaUrlList(urls, this.$store.state.configStore.s3Url);
		},
	},
});

const preloadFont = (href, type) => {
  if (!href || typeof document === 'undefined') return;
  const exists = document.head.querySelector(`link[rel="preload"][href="${href}"]`);
  if (exists) return;
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'font';
  link.type = type;
  link.href = href;
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
};

preloadFont(imIconfontUrl, 'font/ttf');
preloadFont(elementIconsWoffUrl, 'font/woff');
preloadFont(flagFontUrl, 'font/woff2');

new Vue({
  el: '#app',
  // 配置路由
  router,
  store,
  render: h => h(App),
  mounted() {
    // 启动版本检查
    versionChecker.start();
  },
  beforeDestroy() {
    // 停止版本检查
    versionChecker.stop();
  }
})

